export default __webpack_public_path__ + "static/media/NutritionChartOff.eb21ea46.svg";